import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Switch,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  TextField,
} from '@mui/material';
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import './FieldTimeline.css';

const FieldTimeline = () => {
  const [person, setPerson] = useState('John Doe');
  const [date, setDate] = useState('');
  const [activityToggle, setActivityToggle] = useState(true);

  const handlePersonChange = (event) => {
    setPerson(event.target.value);
  };

  const handleDateChange = (event) => {
    setDate(event.target.value);
  };

  const timelineData = [
    { time: '10:11 AM', icon: <LocationSearchingIcon />, action: 'Tracking Started', distance: '-', duration: '-' },
    { time: '11:57 AM', icon: <HourglassTopIcon />, action: 'Stop', distance: '-', duration: '1h 45m' },
    { time: '12:01 PM', icon: <LocalShippingIcon />, action: 'Drive', distance: '1.12 Km', duration: '4m 20s' },
    { time: '12:07 PM', icon: <HourglassTopIcon />, action: 'Stop', distance: '-', duration: '5m 44s' },
    { time: '12:10 PM', icon: <LocalShippingIcon />, action: 'Drive', distance: '1 Km', duration: '2m 29s' },
    { time: '12:12 PM', icon: <HourglassTopIcon />, action: 'Stop', distance: '-', duration: '2m 1s' },
    { time: '12:14 PM', icon: <LocalShippingIcon />, action: 'Drive', distance: '2.63 Km', duration: '7m 11s' },
    { time: '12:21 PM', icon: <HourglassTopIcon />, action: 'Stop', distance: 'Saniyasikuppam Road', duration: '3m 14s' },
    { time: '12:24 PM', icon: <LocalShippingIcon />, action: 'Drive', distance: '0.77 Km', duration: '2m 28s' },
    { time: '12:27 PM', icon: <HourglassTopIcon />, action: 'Stop', distance: 'Poraiyur Road', duration: '23m 56s' },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', p: 2, gap: 2, backgroundColor: '#f8f9fa', height: '100vh' }}>
      {/* Left Section */}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Inputs */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl fullWidth sx={{ '& .MuiInputLabel-root': { color: 'black' } }}>
              <InputLabel shrink id="person-select-label">
                Person
              </InputLabel>
              <Select
                labelId="person-select-label"
                value={person}
                onChange={handlePersonChange}
                displayEmpty
                sx={{
                  border: '1px solid gray',
                  borderRadius: '4px',
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: 'black' },
                    '&.Mui-focused fieldset': { borderColor: 'black' },
                  },
                  '& .MuiSelect-select': {
                    color: person ? 'black' : 'gray', // Makes the text visible and styled
                    backgroundColor: 'white',
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select a Person
                </MenuItem>
                <MenuItem value="Chandru V">Chandru V</MenuItem>
                <MenuItem value="John Doe">John Doe</MenuItem>
                <MenuItem value="Jane Smith">Jane Smith</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Date"
              type="date"
              value={date}
              onChange={handleDateChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  border: '1px solid gray',
                  borderRadius: '4px',
                  '&:hover fieldset': { borderColor: 'black' },
                  '&.Mui-focused fieldset': { borderColor: 'black' },
                },
                '& .MuiInputLabel-root': { color: 'black' },
                '& .MuiInputBase-input': { color: 'black' },
                backgroundColor: 'white',
              }}
            />
          </Grid>
        </Grid>

        {/* Timeline Title */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
            Timeline
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={activityToggle}
                onChange={(e) => setActivityToggle(e.target.checked)}
              />
            }
            label="Activity"
          />
        </Box>

        {/* Timeline */}
        <Box
          sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            p: 2,
            overflowY: 'auto',
            maxHeight: '400px',
          }}
        >
          <Typography sx={{ color: '#555', mb: 1, fontWeight: 'bold' }}>
            {date || 'No Date Selected'} | 46.75 Km | 10h 16m
          </Typography>
          <List>
            {timelineData.map((item, index) => (
              <ListItem
                key={index}
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 3fr 2fr 2fr',
                  alignItems: 'center',
                  p: 0.5,
                  borderBottom: '1px solid #e0e0e0',
                  '&:last-child': { borderBottom: 'none' },
                }}
              >
                <ListItemText primary={item.time} sx={{ color: '#333', fontSize: '14px' }} />
                <ListItemText primary={item.icon} sx={{ textAlign: 'center' }} />
                <ListItemText primary={item.action} sx={{ color: '#333', fontSize: '14px' }} />
                <ListItemText primary={item.distance} sx={{ textAlign: 'center', fontSize: '14px' }} />
                <ListItemText primary={item.duration} sx={{ textAlign: 'center', fontSize: '14px', color: item.duration.includes('h') ? 'green' : 'black' }} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>

      {/* Map Section */}
      <Box
        sx={{
          flex: 1,
          border: '1px solid #ddd',
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.6962717628603!2d80.92190367521856!3d26.75406687674198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfb53706b7d85%3A0xa2330944dc4c56e4!2sRoad%20Pilot%20technologies%20pvt%20ltd!5e0!3m2!1sen!2sin!4v1712893020203!5m2!1sen!2sin"
          style={{ width: '100%', height: '100%' }}
          allowFullScreen="true"
          loading="lazy"
        ></iframe>
      </Box>
    </Box>
  );
};

export default FieldTimeline;
